import { IS_PRODUCTION, ANALYTIC_DEBUG_SHOW_LOG } from "utils/env-management"
import { waitFor } from "utils/ThirdParty/waitFor"
import { Psychologist } from "utils/interfaces"

type Dictionary = {
    [x: string]: string | Dictionary
}

declare global {
    interface Window {
        mindbox: (typeCall: string, params: Dictionary) => void
    }
}

const operationMap: Record<string, string> = {
    survey_started: "SurveyStart",
    viewprofile: "PsychologistPageview",
    booking_widget_shown: "PsychologistBookingDateTime",
    user_went_to_form: "ConfirmationPageView",
}

const pointOfContactMap: Record<string, string> = {
    survey_started: "MainForm",
}

export function mindboxOperationTrack(eventId: string, data?: Record<string, unknown>) {
    if (!operationMap[eventId]) return

    const payload: Dictionary = {
        operation: operationMap[eventId],
    }

    if (eventId === "survey_started") {
        payload.data = {
            pointOfContact: pointOfContactMap[eventId],
        }
    }

    if (
        (eventId === "viewprofile" ||
            eventId === "booking_widget_shown" ||
            eventId === "user_went_to_form") &&
        data
    ) {
        const product = {
            ids: {
                alterMindbox: (data as { psy: Psychologist }).psy.hash_id,
            },
        }

        payload.data = {
            viewProduct: {
                product,
            },
        }

        if (eventId === "user_went_to_form") {
            payload.data.viewProduct = {
                product,
                customerAction: {
                    customFields: {
                        ...(data.customFields as Record<string, string>),
                    },
                },
            }
        }
    }

    if (IS_PRODUCTION) {
        waitFor("mindbox", () => {
            const mindbox = window.mindbox
            if (!mindbox) return
            mindbox("async", payload)
        })
    } else if (ANALYTIC_DEBUG_SHOW_LOG) {
        console.log(`mindbox`, payload)
    }
}
